let _mixpanelPromise = null;
let _inited = false;

function loadMixpanelFromCdn() {
  if (_mixpanelPromise) return _mixpanelPromise;
  _mixpanelPromise = new Promise((resolve) => {
    if (typeof window === "undefined") return resolve(null);
    if (window.mixpanel) return resolve(window.mixpanel);

    const src =
      process.env.VUE_APP_MIXPANEL_SRC ||
      "https://cdn.jsdelivr.net/npm/mixpanel-browser/dist/mixpanel.min.js";

    const s = document.createElement("script");
    s.async = true;
    s.src = src;
    s.onload = () => resolve(window.mixpanel || null);
    s.onerror = () => resolve(null);
    document.head.appendChild(s);
  });
  return _mixpanelPromise;
}

export function initAnalyticsOnce(token, options) {
  if (!token) return;
  if (_inited) return;
  _inited = true;
  loadMixpanelFromCdn().then((mixpanel) => {
    if (!mixpanel) return;
    try {
      mixpanel.init(token, options);
    } catch (e) {
      // ignore
    }
  });
}

export function track(eventName, props) {
  loadMixpanelFromCdn().then((mixpanel) => {
    if (!mixpanel || typeof mixpanel.track !== "function") return;
    try {
      mixpanel.track(eventName, props);
    } catch (e) {
      // ignore
    }
  });
}

